module.exports = __webpack_public_path__ + "static/media/my_image.6389cabc.png";